/* eslint-disable react-hooks/exhaustive-deps */
import { FC, memo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { FaEye, FaPencilAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

import { Button, Tooltip, useTheme } from '@mui/material'
import { format } from 'date-fns'

import { IColumn } from 'types'
import MainTableActionButtons from 'components/organisms/MainTableActionButtons'

export const useTableModel = () => {
  const { t } = useTranslation()

  const handleActionsFormat = useCallback(
    (cellValue: string, row: any, index: number) => <MainTableActionButtons baseUrl={'/meetings/'} row={row} />,
    [],
  )
  
  const handleNameFormat = useCallback((cellValue: string, row: any) => {
    return <>{row.student_groups && row.student_groups+" / "}{cellValue}<br/>
      {row.student_academic_id && "#"+row.student_academic_id}</>
  }, [])

  const handleDateFormat = useCallback(
    (cellValue: string) => (cellValue ? format(new Date(cellValue), 'PPpp') : ''),
    [],
  )
  const columns: IColumn[] = [
    {
      title: `${t('common.status')}`,
      field: 'status',
      order: true,
      width: '7%'
    },
    {
      title: `${t('common.creator')}`,
      field: 'creator',
      order: true,
      width: '10%'
    },
    {
      title: `${t('common.type')}`,
      field: 'type',
      order: true,
      width: '10%'
    },
    {
      title: `${t('common.start-date')}`,
      field: 'start_datetime',
      order: true,
      width: '13%',
      format: handleDateFormat,
    },
    {
      title: `${t('meetings.location')}`,
      field: 'location',
      order: true,
      width: '15%'
    },
    {
      title: `${t('meetings.purpose')}`,
      field: 'purpose',
      order: true,
      width: '15%'
    },
    {
      title: `${t('common.duration-minutes')}`,
      field: 'duration_minutes',
      order: true,
      width: '10%'
    },
    {
      title: `${t('common.student')}`,
      field: 'student',
      order: true,
      width: '10%',
      format: handleNameFormat,
    },
    {
      title: '',
      field: '',
      width: '10%',
      align: 'end',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}